export default {"src":"/_next/static/media/half-star.dae99d0d.svg","height":17,"width":17};